import { useEffect } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../lib/apiBase';
import { DEFAULT_HEADING_FONT, DEFAULT_BODY_FONT, googleFontsHref } from '../lib/fonts';

const API_URL = getApiBaseUrl();

// Applies the platform's heading/body fonts globally via CSS variables on :root
// and injects a Google Fonts <link> for only the two selected fonts.
export const FontLoader = () => {
  useEffect(() => {
    let cancelled = false;
    (async () => {
      let headingFont = DEFAULT_HEADING_FONT;
      let bodyFont = DEFAULT_BODY_FONT;
      try {
        const res = await axios.get(`${API_URL}/settings`);
        if (cancelled) return;
        headingFont = res.data?.heading_font || DEFAULT_HEADING_FONT;
        bodyFont = res.data?.body_font || DEFAULT_BODY_FONT;
      } catch {
        // keep defaults
      }
      if (cancelled) return;

      let link = document.getElementById('platform-fonts-link');
      if (!link) {
        link = document.createElement('link');
        link.id = 'platform-fonts-link';
        link.rel = 'stylesheet';
        document.head.appendChild(link);
      }
      link.href = googleFontsHref([headingFont, bodyFont]);

      const root = document.documentElement.style;
      root.setProperty('--font-heading', `'${headingFont}', serif`);
      root.setProperty('--font-body', `'${bodyFont}', sans-serif`);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default FontLoader;
